import React, { FunctionComponent } from 'react';
import { faClock } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconClock: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faClock} />;

export { BrassIconClock };
